import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { motion } from 'framer-motion';
import Title from '@/components/ui/title';
import PageRoutes from '@/lib/routing/PageRoutes';
import { uiContext } from '@/providers/UIContextProvider';

export default function PageSplash() {
  const { setHeaderVisible } = useContext(uiContext);
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setHeaderVisible(false);
  }, [setHeaderVisible]);

  // --------------------- effect ------------------------

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev: number) => {
        if (prev >= 100) {
          return 100;
          clearInterval(timer);
        }
        const newProgress = prev + 2;
        return newProgress;
      });
    }, 100);

    // cleanup
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      navigate(PageRoutes.intro.path);
    }
  }, [progress, navigate]);

  // --------------------- render ------------------------
  return (
    <div className="flex h-screen flex-col py-10 text-center md:justify-center md:pt-0">
      <motion.img
        src="content/images/logo.png"
        alt="logo"
        className="max-h-40 object-contain"
      />
      <Title i18nKey="splash.title" className="pt-2 text-xl" />
      <div className="-mt-20 flex w-full justify-center overflow-hidden pt-20 md:-mt-40 md:scale-100">
        <img
          src="content/images/heroes.webp"
          alt="hero"
          className="w-full scale-125 object-contain md:max-w-2xl md:scale-100"
        />
      </div>

      {/* preloader */}
      <motion.div
        className="flex w-full justify-center py-4"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: 'easeOut', delay: 0.5 }}
      >
        <div className="h-1 w-full max-w-52 rounded bg-gray-500">
          <div
            className="h-full rounded bg-yellow-500"
            style={{ width: `${progress}%` }}
          />
        </div>
      </motion.div>
    </div>
  );
}
